import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  ArrowBackIosOutlined,
  ArrowForwardIosOutlined,
} from '@material-ui/icons';
import cls from './tabs.module.scss';

const label = {
  padding: '10px 0 16px',
  paddingBottom: '19px',
  display: 'inline-block',
  border: 'none',
  borderBottom: '3px',
  marginRight: '30px',
  cursor: 'pointer',
  outline: 'none',
  color: '#3e3f42',
  fontSize: '18px',
  fontWeight: '500',
  background: 'none',
};
const activeLabel = {
  ...label,
  borderBottom: '3px solid #6758f3',
  color: '#1665d8',
  fontSize: '18px',
  fontWeight: '500',
  marginBottom: '-3px',
};
const errorStyle = {
  ...label,
  color: 'red',
  borderBottom: '3px solid red',
  fontSize: '18px',
  fontWeight: '500',
  marginBottom: '-3px',
};
function Tabs({ defaultIndex, children, del, activeTabsLangLength = null }) {
  const [activeIndex, setActiveIndex] = useState(defaultIndex || 0);
  const tabsLength = activeTabsLangLength ? activeTabsLangLength - 1 : 0;
  useEffect(() => {
    setActiveIndex(tabsLength);
  }, [del, tabsLength]);

  const tabs = React.Children.map(children, (child, index) => {
    const style = activeIndex === index ? activeLabel : label;

    return (
      <div className={cls.buttonStyle}>
        <button
          type="button"
          style={child?.props?.errors ? errorStyle : style}
          onClick={() => setActiveIndex(index)}
        >
          {child.props.label}
        </button>
        {child.props.extraActive && children.length > 1 ? (
          <div
            className={cls.buttonDelete}
            onClick={() => child.props.extraActive(child.key)}
            onKeyDown={() => {}}
            role="button"
            tabIndex={0}
          >
            х
          </div>
        ) : (
          ''
        )}
      </div>
    );
  });

  return (
    <div className={cls.tabs_container}>
      <div className={cls.oneTab_container} id="blockArrow">
        {tabs}
      </div>

      <div className={cls.tabs_arrow}>
        <button
          type="button"
          className={cls.arrow_right}
          onClick={() => {
            document
              .querySelector('#blockArrow')
              .scrollBy({ left: '135', behavior: 'smooth' });
          }}
        >
          <ArrowForwardIosOutlined />
        </button>
        <button
          type="button"
          className={cls.arrow_left}
          onClick={() => {
            document
              .querySelector('#blockArrow')
              .scrollBy({ left: '-135', behavior: 'smooth' });
          }}
        >
          <ArrowBackIosOutlined />
        </button>
      </div>
      {React.Children.map(children, (child, index) => (
        <div style={activeIndex === index ? {} : { display: 'none' }}>
          {child.props.children}
        </div>
      ))}
    </div>
  );
}
Tabs.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  defaultIndex: PropTypes.number.isRequired,
  del: PropTypes.string,
  activeTabsLangLength: PropTypes.number,
};
Tabs.defaultProps = {
  children: [],
};
export default Tabs;
